import Vue from 'vue'
import * as firebase from 'firebase'
import 'firebase/firestore'
import 'firebase/analytics'
import App from './App.vue'
import router from './router'
//import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
//import VueAwesomeSwiper from 'vue-awesome-swiper'
//import VueSilentbox from 'vue-silentbox'
//import WOW from 'wow.js/dist/wow.js';

//Vue.use(VueSilentbox)
//Vue.use(VueRouter)
Vue.use(BootstrapVue)
//Vue.use(VueAwesomeSwiper)

import 'bootstrap/dist/css/bootstrap.css'
import '../src/assets/css/fontawesome-all.min.css'
import 'swiper/dist/css/swiper.css'
import 'animate.css/animate.min.css'
import '../src/assets/scss/style.scss'
import 'slick-carousel/slick/slick.css'


Vue.config.productionTip = false
//Vue.config.productionSourceMap = false

/*
const routes = require('./router/index')
const router = new VueRouter({
    routes,
    mode: 'history'
})
*/

/*
* Firebase
*/

const firebaseConfig = {
    apiKey: 'AIzaSyCsB6izZoSaTriOYOGhL1_UF1M9dTElnv4',
    authDomain: 'apif-prod.firebaseapp.com',
    databaseURL: 'https://apif-prod.firebaseio.com',
    projectId: 'apif-prod',
    storageBucket: 'apif-prod.appspot.com',
    messagingSenderId: '926253227177',
    appId: '1:926253227177:web:401553d4befd50bfec1db8',
    measurementId: "G-R1HG3XD7XT",
}

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics()

Vue.prototype.$db = firebase.firestore();

// Services
import PricingService from '@/services/PricingService';
const pricingService = new PricingService();
Vue.prototype.$pricingService = pricingService;


let app: any = null;

firebase.auth().onAuthStateChanged(() => {
    if (!app) {
        app = new Vue({
            router,
            render: h => h(App),
        }).$mount('#app')
    }
});

/*
new Vue({
    render: h => h(App),
    router,
    mounted() {
        new WOW().init();
    }
}).$mount('#app')
*/
